import {
  Directive,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { ReleaseFeatureFlagToggles } from '../interface/feature-flags.interfaces';
import { DataAccessTogglesFacade } from '../states/toggles/data-access-toggles.facade';

@Directive({
  selector: '[planoneFeatureFlagActive]',
})
export class FeatureFlagActiveDirective implements OnInit, OnChanges, OnDestroy {
  @Input() planoneFeatureFlagActive?: ReleaseFeatureFlagToggles;
  @Input() planoneFeatureFlagActiveElse?: TemplateRef<any>;

  private unsubscribe$ = new Subject<void>();

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private togglesFacade: DataAccessTogglesFacade
  ) {}

  ngOnInit() {
    this.initializeSubscription();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['planoneFeatureFlagActive'] || changes['planoneFeatureFlagActiveElse']) {
      this.unsubscribe$.next();

      this.initializeSubscription();
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private initializeSubscription() {
    if (this.planoneFeatureFlagActive) {
      this.togglesFacade
        .flag(this.planoneFeatureFlagActive)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((status: boolean | undefined) => {
          this.viewContainer.clear();

          if (status) {
            this.viewContainer.createEmbeddedView(this.templateRef);
          } else if (this.planoneFeatureFlagActiveElse) {
            this.viewContainer.createEmbeddedView(this.planoneFeatureFlagActiveElse);
          }
        });
    }
  }
}
